import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../models/Redeem';
import { USER_GROUPS } from '../models/group';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { AUCTIONS } from '../models/auctions';
import * as Globals from '../globals';
const url = Globals.serviceUrl;

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css']
})
export class DownloadComponent implements OnInit {
  authMenu: any;
  loading: boolean;
  series: any[];
  seriesId: number;
  paramSeries: any = { OPEN: false };
  tab: number=1;
  auction: AUCTIONS;
  subregId: number = 0;
  dCloseOpt: any;
  dSettleOpt: any;
  userProfile: any;
  parts: any[];
  group: USER_GROUPS;
  param: any;
  dtFrom: any;
  dtTo: any;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/download/0') {
          this.tab = 1;
          this.router.navigate(['/download/1']);
        }
      };
    });
  }
  ngOnInit() {
    this.dCloseOpt = { format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/download/1']);
    }
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      this.authMenu = Globals.getAuthMenu(701, this.userProfile);
    }
  }

  dopenChanged(event: any) {
    /*this.dCloseOpt = { startDate: this.auction.OPEN_DATE, format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };*/
    if (this.dtFrom > this.dtTo) {
      this.dtTo = this.dtFrom;
    }
    //this.setDSettle();
  }
  dcloseChanged(event: any) {
    //this.setDSettle();
  }
  // setDSettle() {
  //   /*this.dSettleOpt = { startDate: this.auction.CLOSE_DATE, format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };*/
  //   if (this.auction.CLOSE_DATE > this.auction.SETTLE_DATE) {
  //     this.auction.SETTLE_DATE = this.auction.CLOSE_DATE;
  //   }
  // }

  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/downloadseries?t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId == this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              break;
            }
          }
          this.loading = false;
          if (this.userProfile.PARENT_GROUP_ID == null) {
            this.getParts();
          }
        } else if (this.series.length == 0) {
          this.toastr.warning('Tidak ada masa penawaran / Masa penawaran telah berakhir');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  subregIdChanged(ev: any) {
    this.subregId = ev.target.value;
  }

  seriesIdChanged(ev: any) {
    this.seriesId = ev.target.value;
    if (this.series.length > 0) {
      for (var i = 0; i < this.series.length; i++) {
        if (this.seriesId == this.series[i].SERIES_ID) {
          this.paramSeries = this.series[i];
          break;
        }
      }
    }
  }

  getParts() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=2&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.parts = res.json();
        // if (this.parts.length > 0) {
        //   this.group.UD3 = this.parts[0].PA_ID;
        // }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  CSVKSEI() {
    this.param = {TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '", cdauctype:"' + this.paramSeries.CD_AUC_TYPE + '", dtFrom:"' + this.dtFrom +'", dtTo:"' + this.dtTo + '", userId:"' + this.userProfile.USER_ID + '", subregId:"' + this.subregId + '"}'};
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSVOnlineSubreg?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }


}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/download/download.component.ts